import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { xngSubmitContactUsForm } from "@rc/App/Services/ContactUs/contactUsService";

type SubmitContactFormParameter = {
    emailRecipients: string;
    integrateWithSalesForce: boolean;
    salesForceLink: string;
    serializedData: any;
} & HasOnSuccess;

export interface RcSubmitContactUsFormApiParameter extends SubmitContactUsFormApiParameter {
    '00N5b00000EFrRN'?: string;
    '00N5b00000EFrRS'?: string;
    email?: string;
    reason?: string;
    description?: string;
    external?: number;
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, RcSubmitContactUsFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    if (props.parameter.integrateWithSalesForce) {
        props.apiParameter = props.parameter?.serializedData as any;
    } else {
        props.apiParameter = {
            topic: state.fieldValues["topic"],
            firstName: state.fieldValues["firstName"],
            lastName: state.fieldValues["lastName"],
            phoneNumber: state.fieldValues["phoneNumber"],
            emailAddress: state.fieldValues["emailAddress"],
            message: state.fieldValues["message"],
            emailTo: props.parameter.emailRecipients,
        };
    }

};

export const SendDataToApi: HandlerType = async props => {
    if (props.parameter.integrateWithSalesForce) {
        try {
            await xngSubmitContactUsForm(props.parameter.salesForceLink, props.apiParameter);
        } catch(error) {
            console.error(error);
        }
    } else {
        await submitContactUsForm(props.apiParameter);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
